import { AspectRatio, Image } from '@mantine/core'
import { useIntl } from 'react-intl'
import ImagePlaceholder from '@/assets/image-placeholder.png'

type DeploymentCameraImageProps = {
  src?: string | null
  cameraName?: string
}

export const DeploymentCameraImage = ({
  src,
  cameraName
}: DeploymentCameraImageProps) => {
  const intl = useIntl()

  return (
    <AspectRatio ratio={16 / 9}>
      <Image
        fit="cover"
        alt={intl.formatMessage(
          { id: 'deployments.camera.image.alt' },
          { camera: cameraName ?? '' }
        )}
        src={src || ImagePlaceholder}
        fallbackSrc={ImagePlaceholder}
        radius="sm"
        styles={(theme) => ({
          root: {
            outline: `1px solid ${theme.colors.dark[3]}`
          }
        })}
      />
    </AspectRatio>
  )
}
